//@ts-nocheck
import React from "react";
import HomeLayout from "../Pages/HomeLayout/HomeLayout";

// Compatibility adapter for the legacy HomeLayout
export default function UserLayout({ user, children }: { user?: any; children?: React.ReactNode }) {
  // Currently, HomeLayout likely uses an <Outlet /> inside to render nested routes
  // Or it might be rendering {children} if refactored.
  // Given current App.tsx, it's used as: <Route element={<HomeLayout />}> ... </Route>
  // So it relies on react-router's Outlet. We will render it directly.
  return <HomeLayout user={user} />;
}
